/**
 * Created by ah on 04/01/17.
 */
import api from '../apiClient';
import * as Immutable from "immutable";
import {Keys, Actions} from '../constants';
import {defaultAsyncActionFactory} from './action-utils';

export const loadWorkSessions = defaultAsyncActionFactory(
    Actions.GET_WORK_SESSIONS,
    Keys.StoreSliceData.WORK_SESSIONS,
    api.getWorkSessions
);


export const loadCurrentSession = (workSessionId) => (dispatch, getState) => {
    dispatch({type: Actions.GET_CURRENT_WORK_SESSION+'_REQUEST'});
    return api.getCurrentWorkSession(workSessionId).then(response => {
        dispatch({type: Actions.GET_CURRENT_WORK_SESSION+'_SUCCESS', payload: {[Keys.StoreSliceData.CURRENT_WORK_SESSION]: response.data}});
        // send the actual data, so that items and assignees can update their IN_WORK_SESSION
        return dispatch(
            {
                type:Actions.CURRENT_WORK_SESSION_UPDATED,
                payload:{
                    currentWorkSession:getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION)
                }
            }
        );
    }).catch(error => {
        dispatch({type: Actions.GET_CURRENT_WORK_SESSION+'_FAILURE', payload: {message: error.message}});
        return Promise.reject(error);

    })

};
export const loadLastActiveSession = () => (dispatch, getState) => {
    const workSessions = getState().workSessionsState.get(Keys.StoreSliceData.WORK_SESSIONS, Immutable.Map());
    // sessions are ordered last to first
    const firstOpen = workSessions.filter((v, k)=> !v.get('ended')).first();
    if( firstOpen ) {
        return dispatch(loadCurrentSession(firstOpen.get(Keys.ID)));
    }
}
export const createAndLoadNewSession = (workSessionTemplateId) => (dispatch, getState) => {
    dispatch({type: Actions.CREATE_NEW_WORK_SESSION_REQUEST});
    return api.createWorkSession(workSessionTemplateId).then(response => {
        dispatch({type: Actions.CREATE_NEW_WORK_SESSION_SUCCESS, payload: {[Keys.StoreSliceData.CURRENT_WORK_SESSION]: response.data}});
        // send the actual data, so that items and assignees can update their IN_WORK_SESSION
        return dispatch(
            {
                type:Actions.CURRENT_WORK_SESSION_UPDATED,
                payload:{
                    currentWorkSession:getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION)
                }
            }
        );
    }).catch(error => {
        dispatch({type: Actions.CREATE_NEW_WORK_SESSION_FAILURE, payload: {message: error.message}});
        return Promise.reject(error);
    })

};




// WEBPACK FOOTER //
// ./src/model/action-creators/work-session-actions.js